module.exports = __webpack_public_path__ + "img/w22-cover.a266b109.jpg";